import { atom } from "jotai";
import { WorkflowService } from "@/generated";
import { nodesAtom, edgesAtom, isValidDataAtom } from "../atoms";

// ── Trigger validation ────────────────────────────────────────────────────

export const triggerValidationAtom = atom(
  null,
  (get, set, spotGroupId: string) => {
    const nodes = get(nodesAtom);
    const edges = get(edgesAtom);

    const definition = {
      nodes: nodes.map((n) => ({
        id: n.id,
        type: n.data.nodeType,
        name: n.data.name,
        display: { position: n.position },
        node_config: n.data.nodeConfig ?? {},
        variable_bindings: n.data.variableBindings ?? {},
      })),
      edges: edges.map((e) => ({
        id: e.id,
        source: e.source,
        target: e.target,
        source_handle: e.sourceHandle ?? null,
        // Named-input nodes (Merge Paths' path_a/path_b, loop slots) are only
        // valid when the edge names its target handle; dropping it makes the
        // backend flag them as unconnected.
        target_handle: e.targetHandle ?? null,
      })),
    };

    WorkflowService.getIsValidWorkflowV2FromDefinition({
      path: { group_id: spotGroupId },
      body: { definition },
    })
      .then((res) => {
        if (res.data) {
          set(isValidDataAtom, res.data);
        }
      })
      .catch((err) => {
        console.error("Failed to validate workflow", err);
      });
  }
);
